export const START_LOADING = 'START_LOADING';
export const START_POSTING = 'START_POSTING';

export const START_COMPANY_SUMMARY_LOADING = 'START_COMPANY_SUMMARY_LOADING'
export const START_GROUP_SUMMARY_LOADING = 'START_GROUP_SUMMARY_LOADING'

export const START_COMPANY_SCOPE_ONE_LOADING = 'START_COMPANY_SCOPE_ONE_LOADING'
export const START_GROUP_SCOPE_ONE_LOADING = 'START_GROUP_SCOPE_ONE_LOADING'

export const START_COMPANY_SCOPE_TWO_LOADING = 'START_COMPANY_SCOPE_TWO_LOADING'
export const START_GROUP_SCOPE_TWO_LOADING = 'START_GROUP_SCOPE_TWO_LOADING'

export const START_COMPANY_SCOPE_THREE_LOADING = 'START_COMPANY_SCOPE_THREE_LOADING'
export const START_GROUP_SCOPE_THREE_LOADING = 'START_GROUP_SCOPE_THREE_LOADING'

export const GET_EMISSION_FACTORS_SUCCESS = 'GET_EMISSION_FACTORS_SUCCESS';
export const GET_EMISSION_FACTORS_FAIL = 'GET_EMISSION_FACTORS_FAIL';

export const POST_EMISSION_FACTORS_SUCCESS = 'POST_EMISSION_FACTORS_SUCCESS';
export const POST_EMISSION_FACTORS_FAIL = 'POST_EMISSION_FACTORS_FAIL';

// ---- EMISSIONS ----
// COMPANY SUMMARY
export const GET_COMPANY_EMISSIONS_SUMMARY_SUCCESS = 'GET_COMPANY_EMISSIONS_SUMMARY_SUCCESS';
export const GET_COMPANY_EMISSIONS_SUMMARY_FAIL = 'GET_COMPANY_EMISSIONS_SUMMARY_FAIL';
// SCOPE ONE
export const GET_COMPANY_EMISSIONS_SCOPE_ONE_SUCCESS = 'GET_COMPANY_EMISSIONS_SCOPE_ONE_SUCCESS';
export const GET_COMPANY_EMISSIONS_SCOPE_ONE_FAIL = 'GET_COMPANY_EMISSIONS_SCOPE_ONE_FAIL';
// SCOPE TWO
export const GET_COMPANY_EMISSIONS_SCOPE_TWO_SUCCESS = 'GET_COMPANY_EMISSIONS_SCOPE_TWO_SUCCESS';
export const GET_COMPANY_EMISSIONS_SCOPE_TWO_FAIL = 'GET_COMPANY_EMISSIONS_SCOPE_TWO_FAIL';
// SCOPE THREE
export const GET_COMPANY_EMISSIONS_SCOPE_THREE_SUCCESS = 'GET_COMPANY_EMISSIONS_SCOPE_THREE_SUCCESS';
export const GET_COMPANY_EMISSIONS_SCOPE_THREE_FAIL = 'GET_COMPANY_EMISSIONS_SCOPE_THREE_FAIL';
// GROUP SUMMARY
export const GET_GROUP_EMISSIONS_SUMMARY_SUCCESS = 'GET_GROUP_EMISSIONS_SUMMARY_SUCCESS';
export const GET_GROUP_EMISSIONS_SUMMARY_FAIL = 'GET_GROUP_EMISSIONS_SUMMARY_FAIL';
// SCOPE ONE
export const GET_GROUP_EMISSIONS_SCOPE_ONE_SUCCESS = 'GET_GROUP_EMISSIONS_SCOPE_ONE_SUCCESS';
export const GET_GROUP_EMISSIONS_SCOPE_ONE_FAIL = 'GET_GROUP_EMISSIONS_SCOPE_ONE_FAIL';
// SCOPE TWO
export const GET_GROUP_EMISSIONS_SCOPE_TWO_SUCCESS = 'GET_GROUP_EMISSIONS_SCOPE_TWO_SUCCESS';
export const GET_GROUP_EMISSIONS_SCOPE_TWO_FAIL = 'GET_GROUP_EMISSIONS_SCOPE_TWO_FAIL';
// SCOPE THREE
export const GET_GROUP_EMISSIONS_SCOPE_THREE_SUCCESS = 'GET_GROUP_EMISSIONS_SCOPE_THREE_SUCCESS';
export const GET_GROUP_EMISSIONS_SCOPE_THREE_FAIL = 'GET_GROUP_EMISSIONS_SCOPE_THREE_FAIL';
// EXPORT CSV
export const EXPORT_COMPANY_EMISSIONS_SUMMARY_SUCCESS = 'EXPORT_COMPANY_EMISSIONS_SUMMARY_SUCCESS'
export const EXPORT_COMPANY_EMISSION_SUMMARY_FAIL = 'EXPORT_COMPANY_EMISSION_SUMMARY_FAIL'

export const EXPORT_GROUP_EMISSIONS_SUMMARY_SUCCESS = 'EXPORT_GROUP_EMISSIONS_SUMMARY_SUCCESS'
export const EXPORT_GROUP_EMISSIONS_SUMMARY_FAIL = 'EXPORT_GROUP_EMISSIONS_SUMMARY_FAIL'